import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('error');

export default function ActivityTypeForm({ options }) {
  const [state, setState] = useState({ activityTypeName: options.activityTypeName, typeId: options.typeId });

  const model = {
    name: state.activityTypeName,
    visitType: options.visitType,
    id: options.typeId ? options.typeId : null,
  };

  const headerTitle = options.typeId
    ? `Edit ${options.activityTypeName}`
    : `Create${options.visitType === 0 ? ' On Site ' : ' Phone Call Consultations '}Activity Type`;

  const canSave = state.activityTypeName && state.activityTypeName.length > 0 && state.activityTypeName.length <= 50;
  const errorMsg = locale.getMsg('validationMaxLength', ['50']);
  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '400px' }}>
          <div className="sidePanel-header form-header">
            <div className="sidePanel-header-subtitle">
              <Box display="flex">
                <Box flexGrow={1} py={1}>
                  <Typography variant="subtitle1">{headerTitle}</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => options.events.handleSidePanel(false)}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </Box>
            </div>
          </div>
          <div className="sidePanel-content content-top-padding">
            <Typography variant="h6" gutterBottom>
              Activity Type Name
            </Typography>
            <TextField
              required
              fullWidth
              onChange={e => setState({ ...state, activityTypeName: e.target.value })}
              defaultValue={state.activityTypeName}
              error={state.activityTypeName.length > 50}
              helperText={state.activityTypeName.length > 50 ? errorMsg : ''}
            />
          </div>
          <div className="sidePanel-footer">
            <div className="sidePanel-buttons">
              <div className="sidePanel-BackButton">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => options.events.handleSidePanel(false)}
                  style={{ marginRight: '10px' }}
                >
                  Back
                </Button>
              </div>
              <div className="sidePanel-saveButton">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!canSave}
                  onClick={() => options.events.createOrEditActivityType(model)}
                >
                  {options.typeId ? 'Edit' : 'Create'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </section>
  );
}
